export const LIFECYCLE_PLATFORM = Object.freeze({
  AZURE_DEVOPS: "azure_devops",
  JIRA: "jira",
});

export const VCS_PLATFORM = Object.freeze({
  GITHUB: "github",
  AZURE_DEVOPS_GIT: "azure_devops_git",
  SERVICENOW: "servicenow",
  BITBUCKET: "bitbucket",
});

export const HISTORY_DEBOUNCE_MS = 300;
export const HISTORY_PAGE_SIZE   = 10;
export const HISTORY_PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25];
export const HISTORY_POLL_INTERVAL_MS = 5000;

export const HISTORY_POLLING_STATUSES = new Set(["pending", "in_progress"]);

// Single ungrouped group, not a bare array — matches golive/constants.js's
// STATUS_GROUPS shape ({label, options}[]) so the dropdown-rendering JSX can
// be copied over structurally unchanged. ADAI has 4 flat states (vs
// GoLive's 10-state pipeline), so forcing categories here would be
// artificial.
export const HISTORY_STATUS_GROUPS = [
  { label: null, options: ["pending", "in_progress", "completed", "failed"] },
];

export const DEFAULT_DROPDOWN_OPTION = { label: "Select...", value: "" };

export const LIFECYCLE_PLATFORM_DROPDOWN_OPTIONS = [
  DEFAULT_DROPDOWN_OPTION,
  { label: "Azure DevOps", value: LIFECYCLE_PLATFORM.AZURE_DEVOPS },
  { label: "Jira Cloud", value: LIFECYCLE_PLATFORM.JIRA },
];

export const VCS_PLATFORM_DROPDOWN_OPTIONS = [
  DEFAULT_DROPDOWN_OPTION,
  { label: "GitHub", value: VCS_PLATFORM.GITHUB },
  { label: "Azure DevOps", value: VCS_PLATFORM.AZURE_DEVOPS_GIT },
  { label: "ServiceNow", value: VCS_PLATFORM.SERVICENOW },
  { label: "Bitbucket Cloud", value: VCS_PLATFORM.BITBUCKET },
];
